import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks";

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-color-base ${className}`}
            onClick={() => filter.remove()}
        >
            ×
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()
    const [isOpen, setIsOpen] = useState(false);

    const toggleFilters = () => {
        setIsOpen(prev => !prev);
      };

    useEffect(() => {
        const sidebar = document.querySelector('.ns-sidebar-wrapper');
        if (sidebar) {
          if (isOpen) {
            sidebar.classList.add('hide-sidebar');
          } else {
            sidebar.classList.remove('hide-sidebar');
          }
        }
    }, [isOpen]);

    return (

        <>
            <div class="hidden md:inline-flex ns-mr-2 ns-pt-2 ns-pb-2 filter-button-section">
                <button className={`ns-d-flex ns-flex-row ns-align-items-center ns-border-radius-4 see-results-button ${isOpen ? 'filters-clicked' : ''}`} onClick={toggleFilters}>     
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.5 2.75C6.5 2.55109 6.42098 2.36032 6.28033 2.21967C6.13968 2.07902 5.94891 2 5.75 2C5.55109 2 5.36032 2.07902 5.21967 2.21967C5.07902 2.36032 5 2.55109 5 2.75V5.75C5 5.94891 5.07902 6.13968 5.21967 6.28033C5.36032 6.42098 5.55109 6.5 5.75 6.5C5.94891 6.5 6.13968 6.42098 6.28033 6.28033C6.42098 6.13968 6.5 5.94891 6.5 5.75V5H13.25C13.4489 5 13.6397 4.92098 13.7803 4.78033C13.921 4.63968 14 4.44891 14 4.25C14 4.05109 13.921 3.86032 13.7803 3.71967C13.6397 3.57902 13.4489 3.5 13.25 3.5H6.5V2.75ZM11 7C11 6.80109 10.921 6.61032 10.7803 6.46967C10.6397 6.32902 10.4489 6.25 10.25 6.25C10.0511 6.25 9.86032 6.32902 9.71967 6.46967C9.57902 6.61032 9.5 6.80109 9.5 7V10C9.5 10.1989 9.57902 10.3897 9.71967 10.5303C9.86032 10.671 10.0511 10.75 10.25 10.75C10.4489 10.75 10.6397 10.671 10.7803 10.5303C10.921 10.3897 11 10.1989 11 10V9.25H13.25C13.4489 9.25 13.6397 9.17098 13.7803 9.03033C13.921 8.88968 14 8.69891 14 8.5C14 8.30109 13.921 8.11032 13.7803 7.96967C13.6397 7.82902 13.4489 7.75 13.25 7.75H11V7ZM5.75 10.5C5.94891 10.5 6.13968 10.579 6.28033 10.7197C6.42098 10.8603 6.5 11.0511 6.5 11.25V12H13.25C13.4489 12 13.6397 12.079 13.7803 12.2197C13.921 12.3603 14 12.5511 14 12.75C14 12.9489 13.921 13.1397 13.7803 13.2803C13.6397 13.421 13.4489 13.5 13.25 13.5H6.5V14.25C6.5 14.4489 6.42098 14.6397 6.28033 14.7803C6.13968 14.921 5.94891 15 5.75 15C5.55109 15 5.36032 14.921 5.21967 14.7803C5.07902 14.6397 5 14.4489 5 14.25V11.25C5 11.0511 5.07902 10.8603 5.21967 10.7197C5.36032 10.579 5.55109 10.5 5.75 10.5ZM2.75 7.75H8.5V9.25H2.75C2.55109 9.25 2.36032 9.17098 2.21967 9.03033C2.07902 8.88968 2 8.69891 2 8.5C2 8.30109 2.07902 8.11032 2.21967 7.96967C2.36032 7.82902 2.55109 7.75 2.75 7.75ZM4 3.5H2.75C2.55109 3.5 2.36032 3.57902 2.21967 3.71967C2.07902 3.86032 2 4.05109 2 4.25C2 4.44891 2.07902 4.63968 2.21967 4.78033C2.36032 4.92098 2.55109 5 2.75 5H4V3.5ZM2.75 12H4V13.5H2.75C2.55109 13.5 2.36032 13.421 2.21967 13.2803C2.07902 13.1397 2 12.9489 2 12.75C2 12.5511 2.07902 12.3603 2.21967 12.2197C2.36032 12.079 2.55109 12 2.75 12Z" fill="#201E25"/>
                    </svg>
                    <span>{isOpen ? 'Filters' : 'Hide Filters'}</span>
                </button>
            </div>
            {filters.length > 0 && (
                <div class="ns-flex-wrap ns-align-items-center ns-flex-fill-middle ns-w-100 ns-pl-md-2 ns-pr-md-2 ns-pt-2 ns-pb-2">
                    <div class="ns-d-flex ns-flex-wrap ns-align-items-center selected-filters">
                        {filters.map(filter => (
                            <div
                                key={`${filter.name}: ${filter.value}`}
                                class="ns-selected-filter ns-d-flex ns-align-items-center ns-font-5 ns-color-base active-facets__button"
                            >
                                <span class="active-facets__button-inner">
                                    {filter.name}: {filter.value}
                                    <FilterRemoveButton filter={filter} />
                                </span>
                            </div>
                        ))}
                        <span
                            class="ns-anchor-underline ns-col-sm-2 ns-flex-fill-middle ns-font-5 ns-color-grey-medium ns-ml-2 ns-mr-0"
                            onClick={() => {
                                removeAll()
                            }}
                        >
                            Remove all
                        </span>
                    </div>
                </div>
            )}
        </>

    )
}
